import { CheckOutlined } from "@ant-design/icons";
import type { SupportMessage } from "@features/support/api";
import { useMarkSupportMessageRead } from "@features/support/api";
import { useStoredUser } from "@shared/useStoredUser";
import { Button, Flex, Tooltip, Typography, theme } from "antd";
import dayjs from "dayjs";

interface Props {
  messages: SupportMessage[];
  ticketId?: string;
}

const SupportMessageThread = ({ messages, ticketId }: Props) => {
  const user = useStoredUser();
  const { token } = theme.useToken();
  const markRead = useMarkSupportMessageRead(ticketId);

  const handleMarkRead = (messageId: string) => {
    if (!messageId) return;
    markRead.mutate({ id: messageId });
  };

  if (!messages.length) {
    return (
      <Flex align="center" justify="center" style={{ padding: 32 }}>
        <Typography.Text type="secondary">Нет сообщений</Typography.Text>
      </Flex>
    );
  }

  return (
    <Flex vertical gap={8} style={{ padding: "8px 0" }}>
      {messages
        .filter((m) => m.sender_role !== "system")
        .map((msg) => {
          const isMine = msg.sender_id === user?.id;
          const showMarkRead = !isMine && !msg.is_read;
          return (
            <Flex key={msg.id} justify={isMine ? "flex-end" : "flex-start"}>
              <div
                style={{
                  maxWidth: "75%",
                  padding: "8px 12px",
                  borderRadius: token.borderRadius,
                  background: isMine ? token.colorPrimaryBg : token.colorFillSecondary,
                }}
              >
                {!isMine && msg.sender_name && (
                  <Typography.Text strong style={{ fontSize: 12, display: "block" }}>
                    {msg.sender_name}
                  </Typography.Text>
                )}
                <Typography.Text>{msg.body}</Typography.Text>
                <Flex align="center" justify="flex-end" gap={4}>
                  {showMarkRead ? (
                    <Tooltip title="Прочитать">
                      <Button
                        type="text"
                        size="small"
                        icon={<CheckOutlined />}
                        onClick={() => handleMarkRead(msg.id)}
                        disabled={markRead.isPending}
                      />
                    </Tooltip>
                  ) : null}
                  <Typography.Text type="secondary" style={{ fontSize: 11 }}>
                    {msg.createdAt ? dayjs(msg.createdAt).format("DD.MM HH:mm") : ""}
                  </Typography.Text>
                </Flex>
              </div>
            </Flex>
          );
        })}
    </Flex>
  );
};

export default SupportMessageThread;
